import SearchInput from '@/components/common/SearchInput'
import { CheckIcon } from '@/components/icons'
import {
  Box,
  Button,
  Checkbox,
  Menu,
  SelectChangeEvent,
  Stack,
  Typography,
} from '@mui/material'
import { debounce } from 'lodash'
import classes from './styles.module.scss'
import { useAppDispatch, useAppSelector } from '@store/stores'
import {
  EFilterType,
  stationGeoTagDeviceSliceActions,
  stationGeoTagDeviceState,
} from '@store/slices/StataionGeoTagDevice/stationGeoTagDeviceSlice'

interface MenuFilterProps {
  anchorEl?: null | HTMLElement
  onClose?: () => void
  title?: string
  handleFilter?: any
  placeholder?: string
  bindLabel?: string
  name: EFilterType

  /**
   * why plantItem, EmitterItem, soilItem interface different in
   * @see src/types/emitter.ts
   */
  // plants: {
  //   allowableDepletion?: number
  //   description?: string
  //   factor?: number
  //   id?: number
  //   interfaceId?: number
  //   refillTo?: number
  //   rootZone?: number
  //   name?: string
  // }[]
  // emitters: {
  //   efficiency?: number
  //   emitter?: string
  //   id?: number
  //   interfaceId?: number
  //   name?: string
  // }[]
  // soils: {
  //   description?: string
  //   holdingCapacity?: number
  //   id?: number
  //   intakeRate?: number
  //   maxSurfaceAccumulation?: number
  //   wiltingPoint?: number
  //   name?: string
  // }[]
}

interface ICheckList {
  id: number
  title: string
  name: string
}

/**
 * Placeholder passed via parent components
 * Route http://localhost:30000/dashboard/programs
 */
enum EPlaceholderStation {
  SITE_LOCATION = 'Search Site & Location name',
  PLANT = 'Search Plants name',
  EMITTER = 'Search Emitter name',
  SOIL = 'Search Soil name',
}

const MenuFilterStationCXV2 = ({
  anchorEl,
  onClose,
  title,
  handleFilter,
  placeholder,
  bindLabel,
  name,
}: MenuFilterProps) => {
  const open = Boolean(anchorEl)
  const dispatch = useAppDispatch()
  const stationGeoTagDevice = useAppSelector(stationGeoTagDeviceState)

  /**
   * All items in the dropdown
   */
  const options =
    name === EFilterType.PlantIds
      ? stationGeoTagDevice.plants
      : name === EFilterType.EmitterIds
      ? stationGeoTagDevice.emitters
      : stationGeoTagDevice.soils

  /**
   * current filter
   */
  const currentFilter =
    name === EFilterType.PlantIds
      ? stationGeoTagDevice.rawFilter.PlantIds
      : name === EFilterType.EmitterIds
      ? stationGeoTagDevice.rawFilter.EmitterIds
      : stationGeoTagDevice.rawFilter.SoilIds

  const isEmitterName = () => {
    return name === EFilterType.EmitterIds
  }

  const handleCheck = (item: any, title?: string, itemName?: any) => () => {
    dispatch(
      stationGeoTagDeviceSliceActions.changeSinglePlantEmitterSoil({
        type: name,
        value: { ...item },
      }),
    )
  }

  const handleSearch = debounce((event: SelectChangeEvent) => {
    const value = event.target.value.toString().trim()
    dispatch(
      stationGeoTagDeviceSliceActions.searchSinglePlantEmitterSoil({
        type: name,
        value,
      }),
    )
  }, 500)

  /**
   * Handles the filtering logic for plant, emitter, and soil items based on their titles and
   * updates the respective selections. The filtered selections are passed to a parent component
   * and the global state is updated accordingly.
   *
   * This function performs the following tasks:
   * - Filters the `listCheck` array for items with a title corresponding to plants, emitters, and soils.
   * - Maps the filtered items to an array of objects containing `id` and `name`.
   * - Updates the selections by invoking the `handleFilter` callback with the filtered data.
   * - Updates the global state with the same filtered data using the `dispatch` function.
   */
  const handleFilterDone = () => {
    /**
     * Pass the latest selections to the parent component
     * @todo
     * Refactor later, for now we have to trigger because we need to close dropdown-plants|emitters|soils
     * No need to send any object, only need to trigger the function.
     */
    handleFilter()
    /**
     * When user press Done in dropdown-plants|emitters|soils
     * set selected options isShow = true
     */
    dispatch(
      stationGeoTagDeviceSliceActions.searchSinglePlantEmitterSoil({
        type: name,
        value: '',
      }),
    )

    dispatch(
      stationGeoTagDeviceSliceActions.updateSinglePlantEmitterSoil({
        type: name,
      }),
    )
  }

  return (
    <Menu
      id="demo-positioned-menu"
      aria-labelledby="basic-button"
      open={!!open}
      anchorEl={anchorEl}
      onClose={onClose}
      className={classes.menuGroup}
    >
      <Box
        sx={{
          minWidth: '268px',
          padding: '7px 16px 20px 16px',
        }}
      >
        <Typography className={classes.textTitle}>{title}</Typography>

        <SearchInput
          name={`${placeholder}`}
          onChange={handleSearch}
          sx={{ width: '100%' }}
        />

        <Stack
          sx={{
            backgroundColor: '#f2f2f2',
            mt: '10px',
          }}
        >
          {options &&
            options.map(
              (item) =>
                item.isShow && (
                  <Stack
                    key={item.id}
                    direction={'row'}
                    gap={1}
                    alignItems={'center'}
                  >
                    <Checkbox
                      size="small"
                      onChange={handleCheck(
                        item,
                        placeholder,
                        isEmitterName()
                          ? 'emitter' in item && item.emitter
                          : 'description' in item && item.description,
                      )}
                      checked={
                        currentFilter
                          ?.map((filterItem: any) => filterItem.id)
                          .includes(item.id) || false
                      }
                      sx={{
                        color: 'background.bgButton',
                      }}
                      checkedIcon={<CheckIcon sx={{ color: '#004744' }} />}
                    />
                    <Typography>
                      {isEmitterName()
                        ? 'emitter' in item && item.emitter
                        : 'description' in item && item.description}
                    </Typography>
                  </Stack>
                ),
            )}

          <hr />
        </Stack>
      </Box>

      <Stack justifyContent="flex-end" px="16px" pb="4px">
        <Button
          type="submit"
          variant="secondary"
          size="small"
          disableRipple={true}
          className={classes.btnDone}
          onClick={() => handleFilterDone()}
        >
          Done
        </Button>
      </Stack>
    </Menu>
  )
}

export default MenuFilterStationCXV2
